module.exports = __webpack_public_path__ + "static/img/Mainslide_1920x960_012020-04.0a65c0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/Mainslide_1920x960_012020-04.jpg
// module id = vxZy
// module chunks = 0